import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      //component: NotFoundComponent,
      component: () => import("@/views/dashboard/Page404"),
      name: "NotFound",
    },

    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),

      //component: () => import('@/views/dashboard/Login'),
      children: [
        // Dashboard
        
        // Redireciona rota raiz para módulos
        {
          path: "",
          redirect: "modulos",
        },

        {
          name: "Início",
          path: "inicio",
          component: () => import("@/views/dashboard/Inicio"),
        },

        {
          name: "Módulos",
          path: "modulos",
          component: () => import("@/views/dashboard/ModuleSelector"),
        },

        {
          name: "Controle de Acesso",
          component: () => import("@/views/dashboard/Restrito"),
          path: "restrito",
        },

        // Links Externos (Iframe)
        {
          name: "Portal Socios",
          path: "portal-socios",
          component: () => import("@/views/dashboard/ExternalFrame"),
        },
        {
          name: "Velórios em Andamento",
          path: "velorios-andamento",
          component: () => import("@/views/dashboard/ExternalFrame"),
        },
        {
          name: "Recordações",
          path: "recordacoes",
          component: () => import("@/views/dashboard/ExternalFrame"),
        },
        {
          name: "NPS",
          path: "nps",
          component: () => import("@/views/dashboard/ExternalFrame"),
        },
        {
          name: "Assistente de consulta",
          path: "consultaMassa",
          component: () => import("@/views/dashboard/ConsultaMassa"),
          },
        {
          name: "Loja Virtual",
          path: "ecommerce",
          component: () => import("@/views/dashboard/ExternalFrame"),
        },
        {
          name: "Módulo Financeiro",
          path: "modulo-financeiro",
          component: () => import("@/views/dashboard/ExternalFrame"),
          meta: {
            externalUrl:
              process.env.NODE_ENV === "production"
                ? "https://financeiro.gpdf.com.br/"
                : "http://localhost:5173/",
            externalOrigin:
              process.env.NODE_ENV === "production"
                ? "https://financeiro.gpdf.com.br"
                : "http://localhost:5173",
            bridgeAuth: true,
          },
        },
        {
          name: "Módulo Comunicação",
          path: "modulo-comunicacao",
          component: () => import("@/views/dashboard/ExternalFrame"),
          meta: {
            externalUrl:
              process.env.NODE_ENV === "production"
                ? "https://comunicacao.gpdf.com.br/"
                : "http://localhost:5173/",
            externalOrigin:
              process.env.NODE_ENV === "production"
                ? "https://comunicacao.gpdf.com.br"
                : "http://localhost:5173",
            bridgeAuth: true,
          },
        },
        {
          name: "Módulo Comercial",
          path: "modulo-comercial",
          component: () => import("@/views/dashboard/ExternalFrame"),
          meta: {
            externalUrl:
              process.env.NODE_ENV === "production"
                ? "https://comercial.gpdf.com.br/"
                : "http://127.0.0.1:5173/",
            externalOrigin:
              process.env.NODE_ENV === "production"
                ? "https://comercial.gpdf.com.br"
                : "http://127.0.0.1:5173",
            bridgeAuth: true,
          },
        },

        {
          name: "Módulo Assinatura Digital",
          path: "modulo-assinatura-digital",
          component: () => import("@/views/dashboard/ExternalFrame"),
          meta: {
            externalUrl:
              process.env.NODE_ENV === "production"
                ? "https://assinatura.gpdf.com.br/"
                : "http://localhost:8090/",
            externalOrigin:
              process.env.NODE_ENV === "production"
                ? "https://assinatura.gpdf.com.br"
                : "http://localhost:8090",
            bridgeAuth: true,
          },
        },

        {
          name: "Módulo Colaborador",
          path: "modulo-colaborador",
          component: () => import("@/views/dashboard/ExternalFrame"),
          meta: {
            externalUrl:
              process.env.NODE_ENV === "production"
                ? "https://colaborador.gpdf.com.br/"
                : "http://localhost:8081/",
            externalOrigin:
              process.env.NODE_ENV === "production"
                ? "https://colaborador.gpdf.com.br"
                : "http://localhost:8081/",
            bridgeAuth: true,
          },
        },

        {
          name: "Sepultamento",
          path: "sepultamento",
          component: () => import("@/views/dashboard/Sepultamento"),
        },

        {
          name: "Campanha",
          path: "campanha",
          component: () => import("@/views/dashboard/Campanha"),
        },

        {
          name: "Campanha2",
          path: "campanha2",
          component: () => import("@/views/dashboard/Campanha2"),
        },

        {
          name: "Historico",
          path: "historico",
          component: () => import("@/views/dashboard/Historico"),
        },

        {
          name: "Notificacao",
          path: "notificacao",
          component: () => import("@/views/dashboard/Notificacao"),
        },

        {
          name: "Register",
          path: "register",
          component: () => import("@/views/dashboard/Register"),
        },

        {
          name: "Faturamento",
          path: "faturamento",
          component: () => import("@/views/dashboard/Faturamento"),
        },

        {
          name: "Retenção de Vendas",
          path: "retencao",
          component: () => import("@/views/dashboard/RetencaoVendas"),
        },

        {
          name: "Acompanhamento Venda",
          path: "acompanhamentovenda",
          component: () => import("@/views/dashboard/AcompanhamentoVenda"),
        },

        {
          name: "Documentos",
          path: "documentos",
          component: () => import("@/views/dashboard/ConsultaDocumentos"),
        },

        {
          name: "Comissão de Acordo",
          path: "comissao",
          component: () => import("@/views/dashboard/Comissao"),
        },

        {
          name: "Funeraria",
          path: "funeraria",
          component: () => import("@/views/dashboard/Funeraria"),
        },

        {
          name: "Importação Stratws",
          path: "importacao-stratws",
          component: () => import("@/views/dashboard/ImportacaoStratws"),
        },

        

        {
          name: "Loja",
          path: "loja",
          component: () => import("@/views/dashboard/Loja"),
        },

        {
          name: "Comissão de Venda",
          path: "comissaoVenda",
          component: () => import("@/views/dashboard/ComissaoVenda"),
        },

        {
          name: "Simulação de Venda",
          path: "simulacaoVenda",
          component: () => import("@/views/dashboard/SimulacaoVenda"),
        },

        {
          name: "Comissão de Entrega",
          path: "comissaoEntrega",
          component: () => import("@/views/dashboard/ComissaoEntrega"),
        },

        {
          name: "Controle de Vínculo",
          path: "comissaoControle",
          component: () => import("@/views/dashboard/ComissaoControle"),
        },

        {
          name: "Comissões Recebidas",
          path: "comissoesRecebidas",
          component: () => import("@/views/dashboard/ComissoesRecebidas"),
        },

        {
          name: "Ocorrência",
          path: "comissaoConformidade",
          component: () => import("@/views/dashboard/ComissaoNaoConformidade"),
        },

        {
          name: "Vendas Radar",
          path: "vendasRadar",
          component: () => import("@/views/dashboard/VendasRadar"),
        },

        {
          name: "Comissão Alelo",
          path: "comissaoAlelo",
          component: () => import("@/views/dashboard/ComissaoAlelo"),
        },

        {
          name: "Bitrix Lead",
          path: "bitrixLead",
          component: () => import("@/views/dashboard/BitrixLead"),
        },

        {
          name: "Comissão de Funeraria",
          path: "comissaoFuneraria",
          component: () => import("@/views/dashboard/ComissaoFuneraria"),
        },

        {
          name: "Contratos",
          path: "contrato",
          component: () => import("@/views/dashboard/Contrato"),
        },

        {
          name: "Cobrança",
          path: "cobranca",
          component: () => import("@/views/dashboard/Cobranca"),
        },

        {
          name: "Negativado",
          path: "negativados",
          component: () => import("@/views/dashboard/Negativados"),
        },

        {
          name: "Importação",
          path: "importacao",
          component: () => import("@/views/dashboard/Importacao"),
        },

        {
          name: "Indicadores",
          path: "indicadores",
          component: () => import("@/views/dashboard/Indicadores"),
        },

        {
          name: "Invita",
          path: "invita",
          component: () => import("@/views/dashboard/Invita"),
        },

        {
          name: "Fluxo",
          path: "fluxo",
          component: () => import("@/views/dashboard/Fluxo"),
        },
        {
          name: "Fluxo Cobrança",
          path: "fluxo-cobranca",
          component: () => import("@/views/dashboard/FluxoCobranca"),
        },
        {
          name: "Fluxo Vendas",
          path: "fluxo-vendas",
          component: () => import("@/views/dashboard/FluxoVendas"),
        },
        {
          name: "Fluxo Vaso",
          path: "fluxo-colocacao-vaso",
          component: () => import("@/views/dashboard/FluxoColocacaoVaso"),
        },
        {
          name: "Importação APP",
          path: "importacaoapp",
          component: () => import("@/views/dashboard/Importacaoapp"),
        },

        {
          name: "Conciliação",
          path: "conciliacao",
          component: () => import("@/views/dashboard/Conciliacao"),
        },

        {
          name: "Remessa",
          path: "remessa",
          component: () => import("@/views/dashboard/Remessa"),
        },

        // Pages
        {
          name: "Usuário",
          path: "usuario",
          component: () => import("@/views/dashboard/Usuario"),
        },

        // Pages
        {
          name: "Auditoria",
          path: "auditoria",
          component: () => import("@/views/dashboard/Auditoria"),
        },

        // Pages
        {
          name: "Vendas",
          path: "venda",
          component: () => import("@/views/dashboard/Venda"),
        },

        {
          name: "Renegociações",
          path: "acordos",
          component: () => import("@/views/dashboard/Acordos"),
        },

        {
          name: "Vendas entre Empresas",
          path: "vendasEmpresas",
          component: () => import("@/views/dashboard/VendasEmpresas"),
        },

        {
          name: "Receitas",
          path: "receita",
          component: () => import("@/views/dashboard/Receita"),
        },
        {
          name: "Consulta Dinamica",
          path: "consultaDinamica",
          component: () => import("@/views/dashboard/ConsultaDinamica"),
        },

        {
          name: "Inadimplência",
          path: "inadimplencia",
          component: () => import("@/views/dashboard/Inadimplencia"),
        },

        {
          name: "Teste",
          path: "teste",
          component: () => import("@/views/dashboard/Teste"),
        },

        {
          name: "Cancelamento",
          path: "cancelamento",
          component: () => import("@/views/dashboard/Cancelamento"),
        },

        {
          name: "Óbitos",
          path: "obito",
          component: () => import("@/views/dashboard/Obito"),
        },

        {
          name: "Resumo",
          path: "financeiro",
          component: () => import("@/views/dashboard/Financeiro"),
        },

        {
          name: "Contas a Receber",
          path: "contas",
          component: () => import("@/views/dashboard/Contas"),
        },

        {
          name: "Inadimplência Performance",
          path: "inadimplenciaPerformance",
          component: () => import("@/views/dashboard/InadimplenciaPerformance"),
        },

        {
          name: "Acordos",
          path: "acordosPerformance",
          component: () => import("@/views/dashboard/AcordosPerformance"),
        },

        {
          name: "Sinistralidade",
          path: "sinistralidade",
          component: () => import("@/views/dashboard/Sinistralidade"),
        },
        {
          name: "Disparos Clientes",
          path: "mensageria-externa",
          component: () => import("@/views/dashboard/MensageriaExterna"),
        },
        {
          name: "Disparos Colaboradores",
          path: "mensageria-interna",
          component: () => import("@/views/dashboard/MensageriaInterna"),
        },
        {
          name: "Consulta",
          path: "mensageria-consulta",
          component: () => import("@/views/dashboard/MensageriaConsulta"),
        },
        {
          name: "Mensageria em Lote",
          path: "mensageria-lote",
          component: () => import("@/views/dashboard/MensageriaLote"),
        },
        {
          name: "Mensageria Aniversário",
          path: "mensageria-aniversario",
          component: () => import("@/views/dashboard/MensageriaAniversario"),
        },
        {
          name: "Mensageria Automações",
          path: "mensageria-automacao",
          component: () => import("@/views/dashboard/MensageriaAutomacao"),
        },
        {
          name: "Blacklist",
          path: "blacklist",
          component: () => import("@/views/dashboard/Blacklist"),
        },
        {
          name: "Consulta GLPI",
          path: "consulta-glpi",
          component: () => import("@/views/dashboard/ConsultaGLPI"),
        },
        {
          name: "Acompanhamento dos Chamados",
          path: "acompanhamento-glpi",
          component: () => import("@/views/dashboard/AcompanhamentoSetor"),
        },
        {
          name: "Arquivos",
          path: "gestaoArquivos",
          component: () => import("@/views/dashboard/GestaoArquivos"),
        },
        {
          name: "Novos Arquivos",
          path: "novosArquivos",
          component: () => import("@/views/dashboard/NovosArquivos"),
        },
        {
          name: "Consulta de Arquivo",
          path: "consultaArquivo/:id",
          component: () => import("@/views/dashboard/ConsultaArquivo"),
        },
        {
          name: "Gestão de Carteira",
          path: "gestaoCarteira",
          component: () => import("@/views/dashboard/GestaoCarteira"),
        },
        {
          name: "Relatórios Seguro",
          path: "relatoriosSeguro",
          component: () => import("@/views/dashboard/RelatoriosSeguro"),
        },
        {
          name: "Configuração Relatórios Seguro",
          path: "configRelatoriosSeguro",
          component: () => import("@/views/dashboard/RelatoriosSeguroConfig"),
        },
        {
          name: "Colaboradores",
          path: "colaboradores",
          component: () => import("@/views/dashboard/Colaboradores"),
        },
        {
          name: "Grupos de Colaboradores",
          path: "gruposColaboradores",
          component: () => import("@/views/dashboard/GruposColaboradores"),
        },
        {
          name: "Fluxo de Serviços Funerários",
          path: "fluxo-servico-funerario/:idAtendimento?",
          component: () => import("@/views/dashboard/FluxoServicoFunerario"),
        },
        {
          name: "Relatório Funerário",
          path: "relatorio-funerario",
          component: () => import("@/views/dashboard/RelatorioFunerario"),
        },
        {
          name: "Alocações",
          path: "fluxo-alocacoes",
          component: () => import("@/views/dashboard/FluxoAlocacoes"),
        },
        {
          name: "Fluxo de Serviços Cemiteriais",
          path: "fluxo-cemiterial",
          component: () => import("@/views/dashboard/FluxoServicoCemiterais"),
        },
        {
          name: "Documentação de Serviços Funerários",
          path: "documentacao-servico-funerario",
          component: () => import("@/views/dashboard/DocumentacaoServicoFunerario"),
        },
        {
          name: "Falecidos",
          path: "falecidos",
          component: () => import("@/views/dashboard/Falecidos"),
        },
        {
          name: "Chat",
          path: "chat",
          component: () => import("@/views/dashboard/Chat"),
        },
        {
          name: "Chat v2",
          path: "v2chat",
          component: () => import("@/views/dashboard/v2Chat"),
        },
        {
          name: "Filas",
          path: "filas",
          component: () => import("@/views/dashboard/Filas"),
        },
        {
          name: "Templates",
          path: "templates",
          component: () => import("@/views/dashboard/Templates"),
        },
        {
          name: "Parametros",
          path: "parametros",
          component: () => import("@/views/dashboard/Parametros"),
        },
        {
          name: "URAs",
          path: "uras",
          component: () => import("@/views/dashboard/Uras"),
        },
        {
          name: "Consulta Chat",
          path: "consulta-chat",
          component: () => import("@/views/dashboard/ConsultaChat"),
        },
        {
          name: "Painel Chat",
          path: "painel-chat",
          component: () => import("@/views/dashboard/PainelChat"),
        },
        {
          name: "Etiquetas",
          path: "etiquetas",
          component: () => import("@/views/dashboard/SacEtiquetas"),
        },
        {
          name: "Central Consultas Análise",
          path: "central-consultas-analise",
          component: () => import("@/views/dashboard/CentralConsultasAnalise"),
        },
        {
          name: "Central Consultas Saldo",
          path: "central-consultas-saldo",
          component: () => import("@/views/dashboard/CentralConsultasSaldo"),
        },
        {
          name: "Consulta LTV",
          path: "consulta-ltv",
          component: () => import("@/views/dashboard/ConsultaLtv"),
        },
        {
          name: "Campanha Upload",
          path: "campanha-upload",
          component: () => import("@/views/dashboard/CampanhaUpload"),
        },
        {
          name: "TEM Saúde",
          path: "tem-saude",
          component: () => import("@/views/dashboard/TemSaude"),
        },
        {
          name: "TEM Saúde Lote",
          path: "tem-saude-lote",
          component: () => import("@/views/dashboard/TemSaudeLote"),
        },
        {
          name: "Carnê digital",
          path: "carne-digital",
          component: () => import("@/views/dashboard/CarneDigital"),
        },
        {
          name: "Chat Receptivo",
          path: "chat-wazzup",
          component: () => import("@/views/dashboard/ChatWazzup"),
        },
        {
          name: "Bate Papo",
          path: "batepapo",
          component: () => import("@/views/dashboard/BatePapo"),
          meta: {
            hideFooter: true,
          },
        },
        {
          name: "Carnês devolvidos",
          path: "fluxo-carne-devolvidos",
          component: () => import("@/views/dashboard/FluxoCarneDevolvidos"),
        },
      ],
    },
    {
      path: "/login",
      component: () => import("@/views/dashboard/Login"),
    },

    {
      path: "/restrito/atualizacao",
      component: () => import("@/views/restrito/Atualizacao"),
    },
  ],
});
